import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-cancel-payment-success',
  templateUrl: './cancel-payment-success.component.html',
  styleUrls: ['./cancel-payment-success.component.css']
})
export class CancelPaymentSuccessComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CancelPaymentSuccessComponent>,
    public commonService : CommonService
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.commonService.triggerGridRefresh();
  }

  onClick() {
  }


}
